export class Address {
    private city: string | null | undefined;
    private country: string | null | undefined;
    private line1: string | null | undefined;
    private line2: string | null | undefined;
    private postal_code: string | null | undefined;
    private state: string | null | undefined;

    constructor(city: string | null | undefined, country: string | null | undefined, line1: string | null | undefined, line2: string | null | undefined, postal_code: string | null | undefined, state: string | null | undefined) {
        this.setCity(city);
        this.setCountry(country);
        this.setLine1(line1);
        this.setLine2(line2);
        this.setPostalCode(postal_code);
        this.setState(state);
    }

    static fromJson(json:any) {
        return new Address(json.city, json.country, json.line1, json.line2, json.postal_code, json.state);
    }

    setCity(newCity:string | null | undefined) {
        this.city = newCity;
    }
    setCountry(newCountry:string | null | undefined) {
        this.country = newCountry;
    }
    setLine1(newLine1:string | null | undefined) {
        this.line1 = newLine1;
    }
    setLine2(newLine2:string | null | undefined) {
        this.line2 = newLine2;
    }
    setPostalCode(newPostalCode:string | null | undefined) {
        this.postal_code = newPostalCode;
    }
    setState(newState:string | null | undefined) {
        this.state = newState;
    }

    getCity() {
        return this.city;
    }
    getCountry() {
        return this.country;
    }
    getLine1() {
        return this.line1;
    }
    getLine2() {
        return this.line2;
    }
    getPostalCode() {
        return this.postal_code;
    }
    getState() {
        return this.state;
    }
}